/* eslint-disable import/prefer-default-export */
import { treeNodeSubType } from '@/constants/tree';
import { getSubTypeByObjInfo } from '@/utils/tree';
import { isTrue } from '@/utils/boolean';

export const analysisTimeType = {
  CURRENT: {
    value: 'current',
    label: '현재',
  },
  HIST: {
    value: 'hist',
    label: '이력',
  },
};

export const defaultAnalysisTimeType = analysisTimeType.HIST.value;

/**
 * 성능/운영 노드 탭 객체
 * validate function의 경우 해당 탭 제공 여부를 체크하는 function으로 파라미터로 obj객체와 roles(store.getters.roles)객체를 전달 받아 처리하도록 정의한다.
 * obj: {
 *   objManagetypeId,
 *   objDefineId,
 *   objtypeId,
 *   netdeviceFlowApplyFlag, // FLOW 분석 탭 제공 여부. 연관 없는 OBJ는 null로 전달
 *   netinterfaceFlowApplyFlag, // FLOW 분석 탭 제공 여부. 연관 없는 OBJ는 null로 전달
 *   hypervisorType, // 가상화 장비의 경우 하이퍼바이저 타입 제공. (운영 탭 제공 여부 판단에 사용)
 * }
 * @type {Object}
 */
/* eslint-disable no-unused-vars */
export const performanceNodeTabs = {
  summary: {
    name: 'summary',
    label: '요약',
    active: false,
    default: true,
    orderbyIndex: 1,
  },
  analysis: {
    name: 'analysis',
    label: '분석',
    active: false,
    orderbyIndex: 2,
  },
  config: {
    name: 'config',
    label: '구성',
    active: false,
    orderbyIndex: 3,
  },
  event: {
    name: 'event',
    label: '이벤트',
    active: false,
    orderbyIndex: 4,
  },
  'database-flow': {
    name: 'database-flow',
    label: 'Flow 맵',
    active: false,
    orderbyIndex: 5,
    validate: (obj, roles) => getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId) === treeNodeSubType.DBMS,
  },
  'flow-analysis': {
    name: 'flow-analysis',
    label: 'Flow 분석',
    active: false,
    orderbyIndex: 6,
    validate: (obj, roles) => {
      const authFlowAnalysis = roles.some((role) => role === 'FLOW_ADMIN' || role === 'ADMIN');
      const nodeType = getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId);
      const isFlowNode = (nodeType === treeNodeSubType.NETDEVICE && isTrue(obj.netdeviceFlowApplyFlag)) || (nodeType === treeNodeSubType.NETINTERFACE && isTrue(obj.netinterfaceFlowApplyFlag));
      return authFlowAnalysis && isFlowNode;
    },
  },
  listview: {
    name: 'listview',
    label: '가상장비 목록',
    active: false,
    orderbyIndex: 7,
    validate: (obj, roles) => getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId) === treeNodeSubType.VIRTUAL && obj.objtypeId !== 'VVM',
  },
  virtualmap: {
    name: 'virtualmap',
    label: '가상화맵',
    active: false,
    orderbyIndex: 8,
    validate: (obj, roles) => {
      let valid = false;
      if (getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId) === treeNodeSubType.VIRTUAL) {
        const bannedNodeList = ['VVM'];
        if (!bannedNodeList.includes(obj.objtypeId)) {
          valid = true;
        }
      }
      return valid;
    },
  },
  transaction: {
    name: 'transaction',
    label: '트랜잭션 분포',
    active: false,
    orderbyIndex: 9,
    validate: (obj, roles) => getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId) === treeNodeSubType.APM,
  },
  operation: {
    name: 'operation',
    label: '운영',
    active: false,
    orderbyIndex: 10,
    validate: (obj, roles) => {
      const subType = getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId);
      if (subType === treeNodeSubType.SENSOR || subType === treeNodeSubType.E2E || subType === treeNodeSubType.APM || obj.hypervisorType === 'KVM' || obj.hypervisorType === 'XENSERVER') {
        return false;
      }
      return true;
    },
  },
  wirelessmap: {
    name: 'wirelessmap',
    label: '무선 장비 맵',
    active: false,
    orderbyIndex: 11,
    validate: (obj, roles) => {
      const subType = getSubTypeByObjInfo(obj.objManagetypeId, obj.objDefineId, obj.objtypeId);
      if (subType === treeNodeSubType.AP_CONTROLLER || subType === treeNodeSubType.WIRELESS_AP) {
        return true;
      }
      return false;
    },
  },
};
/* eslint-enable no-unused-vars */

export const performanceGroupTabs = {
  performance: {
    name: 'performance',
    label: '성능 정보',
    active: false,
    default: true,
    orderbyIndex: 1,
  },
  config: {
    name: 'config',
    label: '구성 정보',
    active: false,
    orderbyIndex: 2,
  },
};

export const dataTypeDefine = {
  BOOL: 'BOOL',
  INTEGER: 'INTEGER',
  DOUBLE: 'DOUBLE',
  STRING: 'STRING',
};

export const PerformanceAnalysisChartType = {
  MUTIL_OBJ: 'MULTI_OBJ_CHART',
  MUTIL_RSC_KEY: 'MULTI_RSC_KEY_CHART',
};



// WEBPACK FOOTER //
// ./src/constants/performance.js